var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KChip',{attrs:{"red":_vm.options.slug === 'restrict',"yellow":_vm.options.slug === 'private',"green":_vm.options.slug === 'public'},domProps:{"textContent":_vm._s(_vm.options.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }